<div class="alert d-md-flex align-items-center justify-content-between" [ngClass]="state">
    <p class="mb-0">{{msg}}</p>
    <button class="outline mt-md-0 mt-3" [routerLink]="link" *ngIf="buttonText">{{buttonText}}</button>
</div>
